import * as yup from 'yup';

const rootConst = 'FORGOT_PASSWORD_VERIFY_CODE';

export const VERIFY_CODE = `${rootConst}/VERIFY_CODE`;

export const schema = yup.object({
  code: yup
    .string()
    .min(6, 'Atleast 6 characters')
    .required('Please input recovery code.'),
});
